import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=ac27ad6e&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac27ad6e')) {
      api.createRecord('ac27ad6e', component.options)
    } else {
      api.reload('ac27ad6e', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=ac27ad6e&", function () {
      api.rerender('ac27ad6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/PageHeader.vue"
export default component.exports